var _circle, _circle2, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#F0F0F0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9111 26.3916L19.7507 28.2311",
    stroke: "#565656",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 14C25.5 14 27 14.549 28.2285 15.7775C30.5879 18.1369 30.5879 21.984 28.2285 24.3354C26.5809 25.975 24.2215 26.4789 22.15 25.831L18.383 29.5901C18.1111 29.87 17.5752 30.038 17.1913 29.982L15.4478 29.742C14.8719 29.6621 14.336 29.1182 14.2481 28.5423L14.0081 26.7988C13.9521 26.4149 14.1361 25.879 14.4 25.6071L15.2958 24.7113L18.1511 21.856C17.5112 19.7765 17.5 18 19 16",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9975 21.2002C24.6601 21.2002 25.1972 20.663 25.1972 20.0005C25.1972 19.3379 24.6601 18.8008 23.9975 18.8008C23.335 18.8008 22.7979 19.3379 22.7979 20.0005C22.7979 20.663 23.335 21.2002 23.9975 21.2002Z",
    stroke: "#565656",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrivacy);
export default __webpack_public_path__ + "static/media/icon-privacy.c48ddce1291d52d9566735437d895806.svg";
export { ForwardRef as ReactComponent };